import { render, staticRenderFns } from "./HardwareBlockIndexB.vue?vue&type=template&id=94bf427c&scoped=true&"
import script from "./HardwareBlockIndexB.vue?vue&type=script&lang=js&"
export * from "./HardwareBlockIndexB.vue?vue&type=script&lang=js&"
import style0 from "./HardwareBlockIndexB.vue?vue&type=style&index=0&id=94bf427c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bf427c",
  null
  
)

export default component.exports